var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThunderW9H12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3A5244"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1248.283 411c-.063.002-.125.02-.176.054l-6.634 4.326c-.042.027-.076.064-.097.105-.022.042-.031.088-.027.134.003.045.02.09.05.128.028.038.067.07.113.091l2.852 1.331-4.3 5.408c-.21.32.136.527.45.368l8.37-5.885c.04-.028.071-.065.091-.106.02-.041.028-.087.024-.132-.005-.044-.023-.088-.051-.125-.028-.037-.067-.069-.112-.09l-2.724-1.272 2.453-3.932c.026-.042.04-.09.038-.138-.001-.047-.017-.094-.046-.135-.028-.04-.069-.075-.117-.097-.048-.023-.102-.034-.157-.033z",
    transform: "translate(-1240 -411)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderW9H12);
export default __webpack_public_path__ + "static/media/thunder_w9_h12.c521bf7053ffbe50226f2af6097420bb.svg";
export { ForwardRef as ReactComponent };